import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function LimitesConsultas() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [limiteInfo, setLimiteInfo] = useState(null);
  const [usuariosLimites, setUsuariosLimites] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [editandoLimite, setEditandoLimite] = useState(null);
  const [novoLimite, setNovoLimite] = useState('');
  const [limiteInfoCpf, setLimiteInfoCpf] = useState(null);
  const [usuariosLimitesCpf, setUsuariosLimitesCpf] = useState([]);
  const [editandoLimiteCpf, setEditandoLimiteCpf] = useState(null);
  const [novoLimiteCpf, setNovoLimiteCpf] = useState('');
  const [limiteInfoCpfTemCnpj, setLimiteInfoCpfTemCnpj] = useState(null);
  const [usuariosLimitesCpfTemCnpj, setUsuariosLimitesCpfTemCnpj] = useState([]);
  const [editandoLimiteCpfTemCnpj, setEditandoLimiteCpfTemCnpj] = useState(null);
  const [novoLimiteCpfTemCnpj, setNovoLimiteCpfTemCnpj] = useState('');

  useEffect(() => {
    loadCurrentUser();
  }, []);

  useEffect(() => {
    if (currentUser) {
      loadLimiteInfo();
      loadLimiteInfoCpf();
      loadLimiteInfoCpfTemCnpj();
      if (currentUser.role === 'admin' || currentUser.role === 'proprietario') {
        loadUsuariosLimites();
        loadUsuariosLimitesCpf();
        loadUsuariosLimitesCpfTemCnpj();
        loadUsuarios();
      }
    }
  }, [currentUser]);

  const loadCurrentUser = async () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        setCurrentUser(user);
      }
    } catch (err) {
      console.error('Erro ao carregar usuário:', err);
    }
  };

  const loadLimiteInfo = async () => {
    try {
      setLoading(true);
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      const response = await axios.get(`/users/${proprietarioId}/limite-consultas-info`);
      setLimiteInfo(response.data);
    } catch (err) {
      console.error('Erro ao carregar informações de limite:', err);
      setError(err.response?.data?.error || 'Erro ao carregar informações de limite');
    } finally {
      setLoading(false);
    }
  };

  const loadLimiteInfoCpf = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      const response = await axios.get(`/users/${proprietarioId}/limite-info-cpf`);
      setLimiteInfoCpf(response.data);
    } catch (err) {
      console.error('Erro ao carregar informações de limite de CPF:', err);
      // Se não tiver permissão ou limite, não é erro crítico
      setLimiteInfoCpf(null);
    }
  };

  const loadUsuariosLimites = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'admin' && user.id) {
        // Admin precisa selecionar um proprietário
        return;
      }

      const response = await axios.get(`/users/${proprietarioId}/usuarios-limites`);
      setUsuariosLimites(response.data);
    } catch (err) {
      console.error('Erro ao carregar limites de usuários:', err);
    }
  };

  const loadUsuariosLimitesCpf = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'admin' && user.id) {
        // Admin precisa selecionar um proprietário
        return;
      }

      const response = await axios.get(`/users/${proprietarioId}/usuarios-limites-cpf`);
      setUsuariosLimitesCpf(response.data);
    } catch (err) {
      console.error('Erro ao carregar limites de CPF dos usuários:', err);
      setUsuariosLimitesCpf([]);
    }
  };

  const loadLimiteInfoCpfTemCnpj = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }
      if (user.role !== 'proprietario') return; // Só proprietário tem limite CPF tem CNPJ

      const response = await axios.get(`/users/${proprietarioId}/limite-info-cpf-tem-cnpj`);
      setLimiteInfoCpfTemCnpj(response.data);
    } catch (err) {
      console.error('Erro ao carregar informações de limite de CPF tem CNPJ:', err);
      setLimiteInfoCpfTemCnpj(null);
    }
  };

  const loadUsuariosLimitesCpfTemCnpj = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'admin' && user.id) return;

      const response = await axios.get(`/users/${proprietarioId}/usuarios-limites-cpf-tem-cnpj`);
      setUsuariosLimitesCpfTemCnpj(response.data);
    } catch (err) {
      console.error('Erro ao carregar limites de CPF tem CNPJ dos usuários:', err);
      setUsuariosLimitesCpfTemCnpj([]);
    }
  };

  const loadUsuarios = async () => {
    try {
      const response = await axios.get('/users');
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      // Filtrar apenas usuários que pertencem a este proprietário
      const usuariosDoProprietario = response.data.filter(
        u => u.role === 'usuario' && u.criador_id === proprietarioId
      );
      setUsuarios(usuariosDoProprietario);
    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
    }
  };

  const handleDefinirLimiteProprietario = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      if (!currentUser || (currentUser.role !== 'admin' && currentUser.role !== 'proprietario')) {
        setError('Acesso negado');
        return;
      }

      const limite = novoLimite === '' ? null : parseInt(novoLimite);
      if (limite !== null && (isNaN(limite) || limite < 0)) {
        setError('Limite deve ser um número não negativo');
        return;
      }

      if (currentUser.role === 'admin') {
        // Admin precisa do ID do proprietário
        const proprietarioId = prompt('Digite o ID do proprietário:');
        if (!proprietarioId) return;

        await axios.put(`/users/${proprietarioId}/limite-consultas`, { limite_consultas: limite });
      } else {
        // Proprietário atualiza próprio limite (não permitido diretamente, apenas admin)
        setError('Apenas administradores podem definir limite de consultas. Entre em contato com o administrador.');
        return;
      }

      setSuccess('Limite de consultas atualizado com sucesso!');
      setNovoLimite('');
      loadLimiteInfo();
      loadUsuariosLimites();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao definir limite');
    }
  };

  const handleDefinirLimiteUsuario = async (usuarioId, limite) => {
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      const limiteNum = limite === '' || limite === null ? 0 : parseInt(limite);
      if (isNaN(limiteNum) || limiteNum < 0) {
        setError('Limite deve ser um número não negativo');
        return;
      }

      // Se limite for 0, remover limite individual (usar pool compartilhado)
      if (limiteNum === 0) {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas`, { limite_consultas: null });
        setSuccess('Limite individual removido. Usuário usará pool compartilhado.');
      } else {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas`, { limite_consultas: limiteNum });
        setSuccess('Limite individual definido com sucesso!');
      }

      setEditandoLimite(null);
      loadLimiteInfo();
      loadUsuariosLimites();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao definir limite individual');
    }
  };

  const handleDefinirLimiteUsuarioCpf = async (usuarioId, limite) => {
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      const limiteNum = limite === '' || limite === null ? 0 : parseInt(limite);
      if (isNaN(limiteNum) || limiteNum < 0) {
        setError('Limite de CPF deve ser um número não negativo');
        return;
      }

      // Se limite for 0, remover limite individual (usar pool compartilhado)
      if (limiteNum === 0) {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas-cpf`, { limite_consultas: null });
        setSuccess('Limite individual de CPF removido. Usuário usará pool compartilhado.');
      } else {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas-cpf`, { limite_consultas: limiteNum });
        setSuccess('Limite individual de CPF definido com sucesso!');
      }

      setEditandoLimiteCpf(null);
      loadLimiteInfoCpf();
      loadUsuariosLimitesCpf();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao definir limite individual de CPF');
    }
  };

  const handleDefinirLimiteUsuarioCpfTemCnpj = async (usuarioId, limite) => {
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      
      let proprietarioId = user.id;
      if (user.role === 'usuario' && user.criador_id) {
        proprietarioId = user.criador_id;
      }

      const limiteNum = limite === '' || limite === null ? 0 : parseInt(limite);
      if (isNaN(limiteNum) || limiteNum < 0) {
        setError('Limite de CPF tem CNPJ deve ser um número não negativo');
        return;
      }

      if (limiteNum === 0) {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas-cpf-tem-cnpj`, { limite_consultas: null });
        setSuccess('Limite individual de CPF tem CNPJ removido. Usuário usará pool compartilhado.');
      } else {
        await axios.put(`/users/${proprietarioId}/usuarios/${usuarioId}/limite-consultas-cpf-tem-cnpj`, { limite_consultas: limiteNum });
        setSuccess('Limite individual de CPF tem CNPJ definido com sucesso!');
      }

      setEditandoLimiteCpfTemCnpj(null);
      loadLimiteInfoCpfTemCnpj();
      loadUsuariosLimitesCpfTemCnpj();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao definir limite individual de CPF tem CNPJ');
    }
  };

  const getPorcentagem = () => {
    if (!limiteInfo || limiteInfo.limite === null) return 0;
    return (limiteInfo.usadas / limiteInfo.limite) * 100;
  };

  const getCorBarra = () => {
    const porcentagem = getPorcentagem();
    if (porcentagem >= 100) return '#ff0000';
    if (porcentagem >= 90) return '#ff6600';
    return '#00cc66';
  };

  const getPorcentagemCpf = () => {
    if (!limiteInfoCpf || limiteInfoCpf.limite === null) return 0;
    return (limiteInfoCpf.usadas / limiteInfoCpf.limite) * 100;
  };

  const getCorBarraCpf = () => {
    const porcentagem = getPorcentagemCpf();
    if (porcentagem >= 100) return '#ff0000';
    if (porcentagem >= 90) return '#ff6600';
    return '#00cc66';
  };

  const getPorcentagemCpfTemCnpj = () => {
    if (!limiteInfoCpfTemCnpj || limiteInfoCpfTemCnpj.limite === null) return 0;
    return (limiteInfoCpfTemCnpj.usadas / limiteInfoCpfTemCnpj.limite) * 100;
  };

  const getCorBarraCpfTemCnpj = () => {
    const porcentagem = getPorcentagemCpfTemCnpj();
    if (porcentagem >= 100) return '#ff0000';
    if (porcentagem >= 90) return '#ff6600';
    return '#00cc66';
  };

  if (loading) {
    return (
      <div>
        <nav className="nav">
          <Link to="/dashboard" className="nav-link">Dashboard</Link>
          <Link to="/consultas" className="nav-link">Consultas</Link>
          {(JSON.parse(localStorage.getItem('user') || '{}')?.role === 'admin' || 
            JSON.parse(localStorage.getItem('user') || '{}')?.role === 'proprietario') && (
            <Link to="/admin" className="nav-link">Administração</Link>
          )}
        </nav>
        <div className="card">
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  const isAdmin = currentUser?.role === 'admin';
  const isProprietario = currentUser?.role === 'proprietario';

  return (
    <div>
      <nav className="nav">
        <Link to="/dashboard" className="nav-link">Dashboard</Link>
        <Link to="/consultas" className="nav-link">Consultas</Link>
        {(isAdmin || isProprietario) && (
          <Link to="/admin" className="nav-link">Administração</Link>
        )}
      </nav>

      <div className="card">
        <h2 style={{ color: '#cc0000' }}>Gerenciamento de Limites de Consultas</h2>
        <p style={{ color: '#999', marginBottom: '2rem' }}>
          {isAdmin 
            ? 'Gerencie os limites de consultas dos proprietários' 
            : isProprietario 
              ? 'Gerencie seu limite de consultas e distribua entre seus usuários'
              : 'Visualize seu limite de consultas'}
        </p>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* Card de Limite Geral */}
        <div className="card" style={{ marginBottom: '2rem', backgroundColor: '#0a0a0a' }}>
          <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
            {isProprietario || (currentUser?.role === 'usuario') 
              ? 'Seu Limite de Consultas' 
              : 'Limite do Proprietário'}
          </h3>
          
          {limiteInfo?.limite === null ? (
            <div className="alert alert-info">
              <strong>Limite não definido</strong>
              <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                {isAdmin 
                  ? 'Defina um limite para o proprietário através da edição de usuário.'
                  : isProprietario
                    ? 'Entre em contato com o administrador para definir seu limite de consultas.'
                    : 'Entre em contato com seu proprietário ou administrador.'}
              </p>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span style={{ color: '#999' }}>Consultas usadas este mês:</span>
                  <strong style={{ color: getCorBarra() }}>
                    {limiteInfo?.usadas || 0} / {limiteInfo?.limite || 0}
                  </strong>
                </div>
                <div style={{ 
                  width: '100%', 
                  height: '30px', 
                  backgroundColor: '#333', 
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${Math.min(getPorcentagem(), 100)}%`,
                    height: '100%',
                    backgroundColor: getCorBarra(),
                    transition: 'width 0.3s ease'
                  }}></div>
                </div>
              </div>

              <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #333' }}>
                <p style={{ margin: '0.5rem 0', color: '#999' }}>
                  <strong style={{ color: '#cc0000' }}>Restantes:</strong>{' '}
                  <span style={{ color: getCorBarra(), fontWeight: 'bold' }}>
                    {limiteInfo?.restantes !== null ? limiteInfo.restantes : 'Ilimitado'}
                  </span>
                </p>
                <p style={{ margin: '0.5rem 0', color: '#999', fontSize: '0.9rem' }}>
                  <strong>Tipo:</strong> {limiteInfo?.tipo === 'individual' ? 'Limite Individual' : 'Pool Compartilhado'}
                </p>
                {limiteInfo?.limiteIndividual && (
                  <p style={{ margin: '0.5rem 0', color: '#999', fontSize: '0.9rem' }}>
                    <strong>Limite Individual:</strong> {limiteInfo.limiteIndividual} consultas/mês
                  </p>
                )}
              </div>

              {limiteInfo?.restantes === 0 && (
                <div className="alert alert-error" style={{ marginTop: '1rem' }}>
                  <strong>⚠️ Limite Atingido</strong>
                  <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                    Você atingiu o limite de consultas para este mês. O limite será resetado no dia 1 do próximo mês.
                  </p>
                </div>
              )}
            </>
          )}
        </div>

        {/* Seção para Proprietários gerenciarem limites de usuários */}
        {(isProprietario || isAdmin) && usuarios.length > 0 && (
          <div className="card" style={{ backgroundColor: '#0a0a0a' }}>
            <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
              Distribuir Limite entre Usuários (Opcional)
            </h3>
            <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '1rem' }}>
              Você pode definir limites individuais para cada usuário. Se não definir, todos compartilharão o pool total.
            </p>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Usuário</th>
                    <th>Limite Individual</th>
                    <th>Usadas (Mês)</th>
                    <th>Restantes</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((usuario) => {
                    const limiteUsuario = usuariosLimites.find(l => l.usuario_id === usuario.id);
                    return (
                      <tr key={usuario.id}>
                        <td>{usuario.username}</td>
                        <td>
                          {editandoLimite === usuario.id ? (
                            <input
                              type="number"
                              min="0"
                              value={novoLimite}
                              onChange={(e) => setNovoLimite(e.target.value)}
                              placeholder={limiteUsuario ? limiteUsuario.limite_consultas : '0 = pool'}
                              style={{ width: '100px', padding: '0.25rem' }}
                            />
                          ) : (
                            limiteUsuario 
                              ? `${limiteUsuario.limite_consultas} consultas/mês`
                              : 'Pool compartilhado'
                          )}
                        </td>
                        <td>{limiteUsuario ? limiteUsuario.usadas || 0 : '-'}</td>
                        <td>
                          {limiteUsuario 
                            ? Math.max(0, (limiteUsuario.limite_consultas || 0) - (limiteUsuario.usadas || 0))
                            : '-'}
                        </td>
                        <td>
                          {editandoLimite === usuario.id ? (
                            <>
                              <button
                                style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', marginRight: '0.5rem', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                className="btn"
                                onClick={() => handleDefinirLimiteUsuario(usuario.id, novoLimite)}
                              >
                                Salvar
                              </button>
                              <button
                                className="btn btn-secondary"
                                onClick={() => {
                                  setEditandoLimite(null);
                                  setNovoLimite('');
                                }}
                                style={{ fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                              >
                                Cancelar
                              </button>
                            </>
                          ) : (
                            <button
                              style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                              className="btn"
                              onClick={() => {
                                setEditandoLimite(usuario.id);
                                setNovoLimite(limiteUsuario ? limiteUsuario.limite_consultas.toString() : '0');
                              }}
                            >
                              {limiteUsuario ? 'Editar' : 'Definir'}
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Seção de Limites de CPF - Apenas para proprietários */}
        {isProprietario && (
          <>
            {/* Card de Limite de CPF do Proprietário */}
            <div className="card" style={{ marginBottom: '2rem', backgroundColor: '#0a0a0a', marginTop: '2rem' }}>
              <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
                Seu Limite de Consultas de CPF
              </h3>
              
              {limiteInfoCpf === null || limiteInfoCpf.limite === null ? (
                <div className="alert alert-info">
                  <strong>Limite de CPF não definido</strong>
                  <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                    Entre em contato com o administrador para definir seu limite de consultas de CPF.
                  </p>
                </div>
              ) : (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                      <span style={{ color: '#999' }}>Consultas de CPF usadas este mês:</span>
                      <strong style={{ color: getCorBarraCpf() }}>
                        {limiteInfoCpf?.usadas || 0} / {limiteInfoCpf?.limite || 0}
                      </strong>
                    </div>
                    <div style={{ 
                      width: '100%', 
                      height: '30px', 
                      backgroundColor: '#333', 
                      borderRadius: '4px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        width: `${Math.min(getPorcentagemCpf(), 100)}%`,
                        height: '100%',
                        backgroundColor: getCorBarraCpf(),
                        transition: 'width 0.3s ease'
                      }}></div>
                    </div>
                  </div>

                  <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #333' }}>
                    <p style={{ margin: '0.5rem 0', color: '#999' }}>
                      <strong style={{ color: '#cc0000' }}>Restantes:</strong>{' '}
                      <span style={{ color: getCorBarraCpf(), fontWeight: 'bold' }}>
                        {limiteInfoCpf?.restantes !== null ? limiteInfoCpf.restantes : 'Ilimitado'}
                      </span>
                    </p>
                  </div>

                  {limiteInfoCpf?.restantes === 0 && (
                    <div className="alert alert-error" style={{ marginTop: '1rem' }}>
                      <strong>⚠️ Limite de CPF Atingido</strong>
                      <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                        Você atingiu o limite de consultas de CPF para este mês. O limite será resetado no dia 1 do próximo mês.
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Tabela de Limites de CPF dos Usuários */}
            {usuarios.length > 0 && (
              <div className="card" style={{ backgroundColor: '#0a0a0a' }}>
                <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
                  Distribuir Limite de CPF entre Usuários (Opcional)
                </h3>
                <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '1rem' }}>
                  Você pode definir limites individuais de CPF para cada usuário. Se não definir, todos compartilharão o pool total de CPF.
                </p>

                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>Usuário</th>
                        <th>Limite Individual de CPF</th>
                        <th>Usadas (Mês)</th>
                        <th>Restantes</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuarios.map((usuario) => {
                        const limiteUsuarioCpf = usuariosLimitesCpf.find(l => l.usuario_id === usuario.id);
                        return (
                          <tr key={usuario.id}>
                            <td>{usuario.username}</td>
                            <td>
                              {editandoLimiteCpf === usuario.id ? (
                                <input
                                  type="number"
                                  min="0"
                                  value={novoLimiteCpf}
                                  onChange={(e) => setNovoLimiteCpf(e.target.value)}
                                  placeholder={limiteUsuarioCpf ? limiteUsuarioCpf.limite_consultas : '0 = pool'}
                                  style={{ width: '100px', padding: '0.25rem' }}
                                />
                              ) : (
                                limiteUsuarioCpf 
                                  ? `${limiteUsuarioCpf.limite_consultas} consultas CPF/mês`
                                  : 'Pool compartilhado'
                              )}
                            </td>
                            <td>{limiteUsuarioCpf ? (limiteUsuarioCpf.usadas || 0) : '-'}</td>
                            <td>
                              {limiteUsuarioCpf 
                                ? Math.max(0, (limiteUsuarioCpf.limite_consultas || 0) - (limiteUsuarioCpf.usadas || 0))
                                : '-'}
                            </td>
                            <td>
                              {editandoLimiteCpf === usuario.id ? (
                                <>
                                  <button
                                    style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', marginRight: '0.5rem', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                    className="btn"
                                    onClick={() => handleDefinirLimiteUsuarioCpf(usuario.id, novoLimiteCpf)}
                                  >
                                    Salvar
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setEditandoLimiteCpf(null);
                                      setNovoLimiteCpf('');
                                    }}
                                    style={{ fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                  >
                                    Cancelar
                                  </button>
                                </>
                              ) : (
                                <button
                                  style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                  className="btn"
                                  onClick={() => {
                                    setEditandoLimiteCpf(usuario.id);
                                    setNovoLimiteCpf(limiteUsuarioCpf ? limiteUsuarioCpf.limite_consultas.toString() : '0');
                                  }}
                                >
                                  {limiteUsuarioCpf ? 'Editar' : 'Definir'}
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Card de Limite de CPF tem CNPJ do Proprietário */}
            <div className="card" style={{ marginBottom: '2rem', backgroundColor: '#0a0a0a', marginTop: '2rem' }}>
              <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
                Seu Limite de Consultas de CPF tem CNPJ
              </h3>
              
              {limiteInfoCpfTemCnpj === null || limiteInfoCpfTemCnpj?.limite === null ? (
                <div className="alert alert-info">
                  <strong>Limite de CPF tem CNPJ não definido</strong>
                  <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                    Entre em contato com o administrador para definir seu limite de consultas de CPF tem CNPJ.
                  </p>
                </div>
              ) : (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                      <span style={{ color: '#999' }}>Consultas de CPF tem CNPJ usadas este mês:</span>
                      <strong style={{ color: getCorBarraCpfTemCnpj() }}>
                        {limiteInfoCpfTemCnpj?.usadas || 0} / {limiteInfoCpfTemCnpj?.limite || 0}
                      </strong>
                    </div>
                    <div style={{ 
                      width: '100%', 
                      height: '30px', 
                      backgroundColor: '#333', 
                      borderRadius: '4px',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        width: `${Math.min(getPorcentagemCpfTemCnpj(), 100)}%`,
                        height: '100%',
                        backgroundColor: getCorBarraCpfTemCnpj(),
                        transition: 'width 0.3s ease'
                      }}></div>
                    </div>
                  </div>

                  <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #333' }}>
                    <p style={{ margin: '0.5rem 0', color: '#999' }}>
                      <strong style={{ color: '#cc0000' }}>Restantes:</strong>{' '}
                      <span style={{ color: getCorBarraCpfTemCnpj(), fontWeight: 'bold' }}>
                        {limiteInfoCpfTemCnpj?.restantes !== null ? limiteInfoCpfTemCnpj.restantes : 'Ilimitado'}
                      </span>
                    </p>
                  </div>

                  {limiteInfoCpfTemCnpj?.restantes === 0 && (
                    <div className="alert alert-error" style={{ marginTop: '1rem' }}>
                      <strong>⚠️ Limite de CPF tem CNPJ Atingido</strong>
                      <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
                        Você atingiu o limite de consultas de CPF tem CNPJ para este mês. O limite será resetado no dia 1 do próximo mês.
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Tabela de Limites de CPF tem CNPJ dos Usuários */}
            {usuarios.length > 0 && (
              <div className="card" style={{ backgroundColor: '#0a0a0a' }}>
                <h3 style={{ color: '#cc0000', marginBottom: '1rem' }}>
                  Distribuir Limite de CPF tem CNPJ entre Usuários (Opcional)
                </h3>
                <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '1rem' }}>
                  Você pode definir limites individuais de CPF tem CNPJ para cada usuário. Se não definir, todos compartilharão o pool total.
                </p>

                <div className="table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>Usuário</th>
                        <th>Limite Individual CPF tem CNPJ</th>
                        <th>Usadas (Mês)</th>
                        <th>Restantes</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuarios.map((usuario) => {
                        const limiteUsuarioCpfTemCnpj = usuariosLimitesCpfTemCnpj.find(l => l.usuario_id === usuario.id);
                        return (
                          <tr key={usuario.id}>
                            <td>{usuario.username}</td>
                            <td>
                              {editandoLimiteCpfTemCnpj === usuario.id ? (
                                <input
                                  type="number"
                                  min="0"
                                  value={novoLimiteCpfTemCnpj}
                                  onChange={(e) => setNovoLimiteCpfTemCnpj(e.target.value)}
                                  placeholder={limiteUsuarioCpfTemCnpj ? limiteUsuarioCpfTemCnpj.limite_consultas : '0 = pool'}
                                  style={{ width: '100px', padding: '0.25rem' }}
                                />
                              ) : (
                                limiteUsuarioCpfTemCnpj 
                                  ? `${limiteUsuarioCpfTemCnpj.limite_consultas} consultas/mês`
                                  : 'Pool compartilhado'
                              )}
                            </td>
                            <td>{limiteUsuarioCpfTemCnpj ? (limiteUsuarioCpfTemCnpj.usadas || 0) : '-'}</td>
                            <td>
                              {limiteUsuarioCpfTemCnpj 
                                ? Math.max(0, (limiteUsuarioCpfTemCnpj.limite_consultas || 0) - (limiteUsuarioCpfTemCnpj.usadas || 0))
                                : '-'}
                            </td>
                            <td>
                              {editandoLimiteCpfTemCnpj === usuario.id ? (
                                <>
                                  <button
                                    style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', marginRight: '0.5rem', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                    className="btn"
                                    onClick={() => handleDefinirLimiteUsuarioCpfTemCnpj(usuario.id, novoLimiteCpfTemCnpj)}
                                  >
                                    Salvar
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                      setEditandoLimiteCpfTemCnpj(null);
                                      setNovoLimiteCpfTemCnpj('');
                                    }}
                                    style={{ fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                  >
                                    Cancelar
                                  </button>
                                </>
                              ) : (
                                <button
                                  style={{ backgroundColor: '#cc0000', color: '#fff', border: 'none', fontSize: '0.85rem', padding: '0.25rem 0.5rem' }}
                                  className="btn"
                                  onClick={() => {
                                    setEditandoLimiteCpfTemCnpj(usuario.id);
                                    setNovoLimiteCpfTemCnpj(limiteUsuarioCpfTemCnpj ? limiteUsuarioCpfTemCnpj.limite_consultas.toString() : '0');
                                  }}
                                >
                                  {limiteUsuarioCpfTemCnpj ? 'Editar' : 'Definir'}
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default LimitesConsultas;
